import React from "react";

export const ProductDetailSkeleton: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Breadcrumb Skeleton */}
      <div className="mb-6 flex items-center gap-2">
        <div className="h-8 w-24 bg-section-border rounded animate-pulse" />
        <div className="h-4 w-4 bg-section-border rounded animate-pulse" />
        <div className="h-4 w-20 bg-section-border rounded animate-pulse" />
      </div>

      {/* Main Product Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
        {/* Image Gallery Skeleton */}
        <div className="space-y-4">
          <div className="aspect-square bg-section-border rounded-xl animate-pulse" />
          <div className="grid grid-cols-4 gap-2">
            {[...Array(4)].map((_, i) => (
              <div
                key={i}
                className="aspect-square bg-section-border rounded-lg animate-pulse"
              />
            ))}
          </div>
        </div>

        {/* Product Info Skeleton */}
        <div className="space-y-6">
          <div>
            <div className="h-8 bg-section-border rounded w-3/4 mb-4 animate-pulse" />
            <div className="h-4 bg-section-border rounded w-full mb-2 animate-pulse" />
            <div className="h-4 bg-section-border rounded w-5/6 animate-pulse" />
          </div>

          <div className="border-t border-section-border pt-6">
            <div className="h-10 bg-section-border rounded w-1/2 mb-4 animate-pulse" />
            <div className="grid grid-cols-2 gap-3 p-4 bg-section-surface rounded-lg border border-section-border">
              {[...Array(4)].map((_, i) => (
                <div
                  key={i}
                  className="h-12 bg-section-border rounded animate-pulse"
                />
              ))}
            </div>
          </div>

          <div className="border-t border-section-border pt-6">
            <div className="h-12 bg-section-border rounded mb-4 animate-pulse" />
            <div className="flex gap-4">
              <div className="flex-1 h-12 bg-section-border rounded animate-pulse" />
              <div className="h-12 w-12 bg-section-border rounded animate-pulse" />
              <div className="h-12 w-12 bg-section-border rounded animate-pulse" />
            </div>
          </div>
        </div>
      </div>

      {/* Product Tabs Skeleton */}
      <div className="bg-section-surface rounded-xl shadow-sm mb-8 border border-section-border">
        <div className="border-b border-section-border p-6">
          <div className="flex gap-8">
            <div className="h-8 w-32 bg-section-border rounded animate-pulse" />
            <div className="h-8 w-32 bg-section-border rounded animate-pulse" />
          </div>
        </div>
        <div className="p-6 space-y-4">
          <div className="h-4 bg-section-border rounded w-full animate-pulse" />
          <div className="h-4 bg-section-border rounded w-5/6 animate-pulse" />
          <div className="h-4 bg-section-border rounded w-4/6 animate-pulse" />
        </div>
      </div>

      {/* Reviews Skeleton */}
      <div className="mt-12 border-t border-section-border pt-8">
        <div className="h-8 w-48 bg-section-border rounded mb-6 animate-pulse" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className="bg-section-surface p-6 rounded-lg border border-section-border">
            <div className="h-12 w-24 bg-section-border rounded mx-auto mb-2 animate-pulse" />
            <div className="h-6 w-32 bg-section-border rounded mx-auto animate-pulse" />
          </div>
          <div className="space-y-2">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="h-8 bg-section-border rounded animate-pulse"
              />
            ))}
          </div>
        </div>
      </div>

      {/* Recommended Products Skeleton */}
      <div className="mt-12">
        <div className="h-8 w-48 bg-section-border rounded mb-6 animate-pulse" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="space-y-3">
              <div className="aspect-square bg-section-border rounded-lg animate-pulse" />
              <div className="h-4 bg-section-border rounded w-3/4 animate-pulse" />
              <div className="h-6 bg-section-border rounded w-1/2 animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const ProductCardSkeleton: React.FC = () => {
  return (
    <div className="bg-section-surface rounded-lg border border-section-border overflow-hidden">
      <div className="aspect-square bg-section-border animate-pulse" />
      <div className="p-4 space-y-3">
        <div className="h-4 bg-section-border rounded w-3/4 animate-pulse" />
        <div className="h-6 bg-section-border rounded w-1/2 animate-pulse" />
        <div className="h-10 bg-section-border rounded animate-pulse" />
      </div>
    </div>
  );
};
